const gameStateKey = (id = "default") => `gameState-${id}`;
const historyKey = (userId = "anon") => `progress-history-${userId}`;
const gameStatKey = "gameStats";

export const saveGameStateToLocalStorage = (gameState, id = "default") => {
    localStorage.setItem(gameStateKey(id), JSON.stringify(gameState));
};

export const loadGameStateFromLocalStorage = (id = "default") => {
    const state = localStorage.getItem(gameStateKey(id));
    return state ? JSON.parse(state) : null;
};

export const saveStatsToLocalStorage = (gameStats) => {
    localStorage.setItem(gameStatKey, JSON.stringify(gameStats));
};

export const loadStatsFromLocalStorage = () => {
    const stats = localStorage.getItem(gameStatKey);
    return stats ? JSON.parse(stats) : null;
};

export const saveHistoryToLocalStorage = (userId, history = []) => {
    localStorage.setItem(historyKey(userId), JSON.stringify(history));
};

export const loadHistoryFromLocalStorage = (userId) => {
    const history = localStorage.getItem(historyKey(userId));
    return history ? JSON.parse(history) : [];
};
